import { Trans } from '@lingui/macro'
import ConfigureMultilanguageTextFieldWithCKEditor from 'app/views/internal/ConfigureMultilanguageTextFieldWithCKEditor'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PdfPropsForm } from '../../common/PdfPropsForm'
import { FormHtml } from './FormHtmlInjector'

export const FormEditorHtml = ({
  editMode,
  depth,
  typeProps,
  showPdfProps,
  showPdfComponent,
  injectable,
  isInsideGroup,
  ...props
}) => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.user)
  const langVersion = user.language
  const { html, pdfFontSize } = typeProps
  const [dialogOpen, setDialogOpen] = useState(false)
  if (!editMode) {
    return <FormHtml editor {...props} typeProps={typeProps} />
  }

  return (
    <div>
      <ConfigureMultilanguageTextFieldWithCKEditor
        value={html}
        label={<Trans>Html</Trans>}
        langVersion={langVersion}
        handleChange={value => {
          const toSet = { ...typeProps }
          toSet.html = value
          dispatch({
            type: 'FIELD',
            injectable,
            depth: depth.split('.'),
            fieldName: 'typeProps',
            fieldValue: { ...toSet }
          })
        }}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
      />
      {showPdfProps && (
        <PdfPropsForm
          typeProps={typeProps}
          dispatch={dispatch}
          injectable={injectable}
          depth={depth}
          showFontSizeOption
          isInsideGroup={isInsideGroup}
        />
      )}
    </div>
  )
}
